import { fetcher } from '@commenda/utils';

import { TCreateBillingPriceParams } from './types';

export const createBillingPrice = async (params: TCreateBillingPriceParams) => {
  const response = await fetcher('commenda-billing/catalog/prices', {
    method: 'POST',
    body: params,
  });

  return response;
};
